import { Avatar, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, InputLabel, Tooltip, Pagination, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Typography } from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import MUIButton from "../../reusable_components/components/MUIButton"
import MUICancelButton from "../../reusable_components/components/MuiCancelButton"
import { useProfileInRecruiterTrackerDialogMutation, useRecruiterTrackerReportListMutation } from "../../redux/reports/reports.api"
import { useContext, useEffect, useState } from "react"
import dayjs from "dayjs"
import { SnackbarContext } from "../../reusable_components/components/Snackbar"
import { TableLoader } from "../../reusable_components/components/TableLoader"
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CalendarIcon from "../../assets/Icons/CalendarIcon"
import DownloadIcon from "../../assets/Icons/DownloadIcon"
import CloseIcon from '@mui/icons-material/Close';
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker"
import { useNavigate } from "react-router-dom"

const PerformanceTracker = () => {

    const [page, setPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [totalCount, setTotalCount] = useState(0)
    const [selectedFromDate, setSelectedFromDate] = useState(null)
    const [selectedToDate, setSelectedToDate] = useState(null)
    const [trackerReportListDatas, setTrackerReportListDatas] = useState([])
    const [showTableLoader, setShowTableLoader] = useState(false)
    const [open, setOpen] = useState(false)
    const [downloadProgress, setDownloadProgress] = useState(null)

    const [eventTypeName, setEventTypeName] = useState("")
    const [eventTypeId, setEventTypeId] = useState("")
    const [totalProfile, setTotalProfile] = useState("")
    const [profileNameArr, setProfileNameArr] = useState([])
    const [userName, setUserName] = useState("")
    const [userId, setUserId] = useState("")
    const { Snackbar } = useContext(SnackbarContext)
    const [dashBoardDisabled, setDashBoardDisabled] = useState(false)
    const navigate = useNavigate()

    const handleOpen = (item, eventTypeId, totalProfile) => {
        if (totalProfile !== 0) {
            setOpen(true)
        }

        let eventTypeName;
        if (eventTypeId === 20) {
            eventTypeName = "Profile Sourced"
        } else if (eventTypeId === 1) {
            eventTypeName = "Profile Identified"
        } else if (eventTypeId === 4) {
            eventTypeName = "Rejected Internal"
        } else if (eventTypeId === 6) {
            eventTypeName = "Scheduled Client"
        } else if (eventTypeId === 5) {
            eventTypeName = "Submitted To Client"
        } else if (eventTypeId === 7) {
            eventTypeName = "Rejected Client"
        } else if (eventTypeId === 9) {
            eventTypeName = "Offered"
        } else if (eventTypeId === 11) {
            eventTypeName = "Declined"
        } else if (eventTypeId === 10) {
            eventTypeName = "Joined"
        }

        setUserName(item?.userName)
        setEventTypeName(eventTypeName)
        setTotalProfile(totalProfile)
        setUserId(item?.userId)
        setEventTypeId(eventTypeId)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handlePageChange = (e, newPage) => {
        setPage(newPage)
    }

    const handleRowsPerPageChange = (e) => {
        const value = +e.target.value
        setRowsPerPage(value)
        setPage(0)
    }

    const [recruiterTrackerReportList] = useRecruiterTrackerReportListMutation()
    const [profileInRecruiterTrackerDialog] = useProfileInRecruiterTrackerDialogMutation()

    const handleFromDateChange = (value) => {
        setSelectedFromDate(value)

        if (selectedToDate && selectedToDate <= value) {
            setSelectedToDate(null)
        }
    }

    const handleToDateChange = (value) => {
        setSelectedToDate(value)
    }

    const getNextDay = (fromDate) => {
        if (!fromDate) {
            return null
        }

        return dayjs(fromDate)?.add(1, 'day')
    }

    useEffect(() => {
        const getDialog = async () => {
            try {
                const fromDate = selectedFromDate ? dayjs(selectedFromDate).format('YYYY-MM-DD') : null
                const toDate = selectedToDate ? dayjs(selectedToDate).format('YYYY-MM-DD') : null

                const payload = {
                    eventTypeId: eventTypeId,
                    fromDate: fromDate || null,
                    toDate: toDate || null,
                    userId: userId
                }

                if (open) {
                    const response = await profileInRecruiterTrackerDialog(payload).unwrap()
                    if (response?.status === 200) {
                        setProfileNameArr(response?.response || [])
                    }
                }
            } catch (err) {
                Snackbar('Network error', 'error')
            }
        }
        getDialog()
    }, [profileInRecruiterTrackerDialog, open])

    const getTableDatas = async () => {
        try {
            const fromDate = selectedFromDate ? dayjs(selectedFromDate).format('YYYY-MM-DD') : null
            const toDate = selectedToDate ? dayjs(selectedToDate).format('YYYY-MM-DD') : null

            const payload = {
                fromDate: fromDate || null,
                page: (page - 1),
                size: rowsPerPage,
                toDate: toDate || null
            }

            const response = await recruiterTrackerReportList(payload).unwrap()
            setShowTableLoader(false)
            if (response?.status === 200) {
                setTrackerReportListDatas(response?.response?.data || [])
                setTotalCount(response?.response?.count)
            }
        } catch (err) {
            Snackbar('Network error', 'error')
            setShowTableLoader(false)
        }
    }

    useEffect(() => {
        setShowTableLoader(true)
        getTableDatas()
    }, [page, rowsPerPage])

    const handleFetchTableDatas = () => {
        getTableDatas()
    }

    const handleExcelDownload = async () => {
        try {
            setDownloadProgress(0); // start at 0%

            const fromDate = selectedFromDate ? dayjs(selectedFromDate).format('YYYY-MM-DD') : null;
            const toDate = selectedToDate ? dayjs(selectedToDate).format('YYYY-MM-DD') : null;

            const payload = {
                fromDate: fromDate || null,
                toDate: toDate || null,
            };

            const token = localStorage.getItem('token');
            setDashBoardDisabled(true)
            const response = await fetch(window.REACT_APP_BASE_URL + `sourcedByReportDownload`, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            setDashBoardDisabled(false)

            if (!response.ok) throw new Error('Network response was not ok');

            const contentLength = response.headers.get('Content-Length');
            if (!contentLength) {
                // If content length not available, just download normally
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'Recruiter Details.xlsx';
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);
                setDownloadProgress(100);
                setTimeout(() => setDownloadProgress(null), 1000);
                return;
            }

            const total = parseInt(contentLength, 10);
            let loaded = 0;

            const reader = response.body.getReader();
            const chunks = [];

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                chunks.push(value);
                loaded += value.length;
                setDownloadProgress(Math.floor((loaded / total) * 100));
            }

            // Combine chunks into one Uint8Array
            const blob = new Blob(chunks, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Recruiter Details.xlsx';
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);

            setDownloadProgress(100);
            setTimeout(() => setDownloadProgress(null), 1000);

        } catch (err) {
            Snackbar('Network error', 'error');
            setDownloadProgress(null);
        }
    };



    return (
        <Box className='container'>
            <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px', marginBottom: '20px' }} onClick={() => navigate(-1)}>
                <ArrowBackIcon sx={{ fontSize: '17px' }} />
                <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
            </Grid2>
            <Typography className="title">Recruiter Performance Tracker</Typography>

            <Grid2 item>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    scroll="paper"
                    maxWidth='md'
                    sx={{
                        "& .MuiDialog-paper": {
                            minWidth: '45vw',
                            minHeight: '65vh'
                        },
                    }}
                >
                    <DialogTitle sx={{ fontWeight: 550, fontSize: '18px', display: 'flex', justifyContent: 'space-between' }}>
                        {userName}'s {eventTypeName}
                        <CloseIcon sx={{ color: '#52525B', cursor: 'pointer' }} onClick={handleClose} />
                    </DialogTitle>
                    <DialogContent dividers>
                        <DialogContentText>
                            <Grid2 item sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Typography sx={{ fontSize: '14px', color: '#000' }}>Total Profile: <span style={{ fontWeight: 'bold' }}> {totalProfile} </span></Typography>
                            </Grid2>

                            <Grid2 item>
                                {profileNameArr?.length > 0 ? (
                                    profileNameArr?.map((item, index) => (
                                        <div style={{ color: '#000', fontSize: '14px' }}>
                                            {`${index + 1}) `}
                                            {item?.profileName} - {item?.profileId}
                                        </div>
                                    ))
                                ) : (
                                    <div className="emptydatas">No Data Found</div>
                                )}
                            </Grid2>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <MUICancelButton title='Close' onClick={handleClose} />
                    </DialogActions>
                </Dialog>
            </Grid2>

            <Grid2 container sx={{ marginTop: '15px' }}>
                <Paper sx={{ width: '100%', overflow: 'auto', border: '1px solid #E9EAEB' }} elevation={0}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={100}>
                                    <div style={{ display: 'flex', gap: '25px' }}>
                                        <Grid2 item sx={{ width: '20%' }}>
                                            <InputLabel className="inputlabels">From Date</InputLabel>
                                            <MuiDatePicker
                                                value={selectedFromDate}
                                                onChange={handleFromDateChange}
                                                slots={{
                                                    openPickerIcon: CalendarIcon
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        size: 'small',
                                                        placeholder: 'Choose From Date',
                                                        InputProps: {
                                                            sx: { borderRadius: '10px', height: '35px' }
                                                        }
                                                    }
                                                }}
                                                sx={{
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px'
                                                    },
                                                    "& .MuiSvgIcon-root": {
                                                        fontSize: '20px'
                                                    }
                                                }}
                                                format="DD-MM-YYYY"
                                            />
                                        </Grid2>

                                        <Grid2 item sx={{ width: '20%' }}>
                                            <InputLabel className="inputlabels">To Date</InputLabel>
                                            <MuiDatePicker
                                                value={selectedToDate}
                                                onChange={handleToDateChange}
                                                slots={{
                                                    openPickerIcon: CalendarIcon
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        size: 'small',
                                                        placeholder: 'Choose To Date',
                                                        InputProps: {
                                                            sx: { borderRadius: '10px', height: '35px' }
                                                        }
                                                    }
                                                }}
                                                sx={{
                                                    "& .MuiInputBase-input": {
                                                        fontSize: '14px'
                                                    },
                                                    "& .MuiSvgIcon-root": {
                                                        fontSize: '20px'
                                                    }
                                                }}
                                                format="DD-MM-YYYY"
                                                minDate={getNextDay(selectedFromDate) || null}
                                                maxDate={dayjs()}
                                                disabled={!selectedFromDate}
                                            />
                                        </Grid2>

                                        <Grid2 item sx={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'column' }}>
                                            <div style={{ display: 'flex', gap: '20px' }}>
                                                <MUIButton title='View' onClick={handleFetchTableDatas} sx={{ backgroundColor: '#7F56D9' }} />
                                                {
                                                    trackerReportListDatas?.length > 0 && (
                                                        <Tooltip
                                                            title={dashBoardDisabled === true && ('Please Wait...')}
                                                            componentsProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        backgroundColor: 'black',
                                                                        color: 'white',
                                                                        '& .MuiTooltip-arrow': {
                                                                            color: 'black',
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            arrow
                                                        >
                                                            <MUIButton
                                                                title={downloadProgress !== null ? `Downloading... ${downloadProgress}%` : 'Download'}
                                                                disabled={dashBoardDisabled}
                                                                startIcon={<DownloadIcon stroke={'white'} />}
                                                                onClick={handleExcelDownload} sx={{ color: 'white', border: '1px solid #D6BBFB', width: '200px' }} />
                                                        </Tooltip>
                                                    )}
                                            </div>
                                        </Grid2>
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="tableHeadersCell">User Name</TableCell>
                                <TableCell className="tableHeadersCell">Profile Sourced</TableCell>
                                <TableCell className="tableHeadersCell">Profile Identified</TableCell>
                                <TableCell className="tableHeadersCell">Rejected Internal</TableCell>
                                <TableCell className="tableHeadersCell">Scheduled Client</TableCell>
                                <TableCell className="tableHeadersCell">Submitted To Client</TableCell>
                                <TableCell className="tableHeadersCell">Rejected Client</TableCell>
                                <TableCell className="tableHeadersCell">Offered</TableCell>
                                <TableCell className="tableHeadersCell">Declined</TableCell>
                                <TableCell className="tableHeadersCell">Joined</TableCell>
                            </TableRow>
                        </TableHead>

                        {!showTableLoader ? (
                            trackerReportListDatas?.length > 0 ? (
                                <TableBody>
                                    {trackerReportListDatas?.map((item, index) => {
                                        const firstLetter = item?.userName
                                        const letter = firstLetter?.charAt(0)?.toUpperCase()
                                        const colors = ['green', "darkorange", 'purple', "#3357FF", 'orangered', "darkgreen", 'pink']
                                        const backgroundColor = colors[index % colors?.length]
                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                    '&:hover': { backgroundColor: '#f1f1f1' },
                                                }}

                                            >
                                                <TableCell className="tableBodyCell">
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px', minWidth: '150px' }}>
                                                        <Avatar sx={{ backgroundColor: backgroundColor, width: 30, height: 30, fontSize: '14px' }}>{letter}</Avatar>
                                                        {item?.userName}
                                                    </Box>
                                                </TableCell>
                                                <TableCell className="tableBodyCell"
                                                    onClick={() => handleOpen(item, item?.profileSourcedId, item?.profileSourced)}
                                                    sx={{ color: item?.profileSourced !== 0 ? '#6941C6' : '#181D27', cursor: 'pointer' }}
                                                >
                                                    {item?.profileSourced}
                                                </TableCell>
                                                <TableCell className="tableBodyCell"
                                                    onClick={() => handleOpen(item, item?.profileIdentifiedId, item?.profileIdentified)}
                                                    sx={{ color: item?.profileIdentified !== 0 ? '#6941C6' : '#181D27', cursor: 'pointer' }}
                                                >
                                                    {item?.profileIdentified}
                                                </TableCell>
                                                <TableCell className="tableBodyCell"
                                                    onClick={() => handleOpen(item, item?.rejectedInternalId, item?.rejectedInternal)}
                                                    sx={{
                                                        color: item?.rejectedInternal !== 0 && '#6941C6',
                                                        cursor: item?.rejectedInternal !== 0 && 'pointer'
                                                    }}
                                                >
                                                    {item?.rejectedInternal}
                                                </TableCell>

                                                <TableCell className="tableBodyCell"
                                                    onClick={() => handleOpen(item, item?.scheduledClientId, item?.scheduledClient)}
                                                    sx={{
                                                        color: item?.scheduledClient !== 0 && '#6941C6',
                                                        cursor: item?.scheduledClient !== 0 && 'pointer'
                                                    }}
                                                >
                                                    {item?.scheduledClient}
                                                </TableCell>

                                                <TableCell className="tableBodyCell"
                                                    onClick={() => handleOpen(item, item?.submittedToClientId, item?.submittedToClient)}
                                                    sx={{
                                                        color: item?.submittedToClient !== 0 && '#6941C6',
                                                        cursor: item?.submittedToClient !== 0 && 'pointer'

                                                    }}
                                                >{item?.submittedToClient}
                                                </TableCell>

                                                <TableCell className="tableBodyCell"
                                                    onClick={() => handleOpen(item, item?.rejectedClientId, item?.rejectedClient)}
                                                    sx={{
                                                        color: item?.rejectedClient !== 0 && '#6941C6',
                                                        cursor: item?.rejectedClient !== 0 && 'pointer'
                                                    }}
                                                >{item?.rejectedClient}
                                                </TableCell>

                                                <TableCell className="tableBodyCell"
                                                    onClick={() => handleOpen(item, item?.offeredId, item?.offered)}
                                                    sx={{
                                                        color: item?.offered !== 0 && '#6941C6',
                                                        cursor: item?.offered !== 0 && 'pointer'
                                                    }}
                                                >
                                                    {item?.offered}
                                                </TableCell>

                                                <TableCell className="tableBodyCell"
                                                    onClick={() => handleOpen(item, item?.declinedId, item?.declined)}
                                                    sx={{
                                                        color: item?.declined !== 0 && '#6941C6',
                                                        cursor: item?.declined !== 0 && 'pointer'
                                                    }}
                                                >
                                                    {item?.declined}
                                                </TableCell>

                                                <TableCell className="tableBodyCell"
                                                    onClick={() => handleOpen(item, item?.joinedId, item?.joined)}
                                                    sx={{
                                                        color: item?.joined !== 0 && '#6941C6',
                                                        cursor: item?.joined !== 0 && 'pointer'
                                                    }}
                                                >
                                                    {item?.joined}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            ) : (
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={8}>
                                            <Typography className="emptydatas">No Data Found</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )
                        ) : (
                            <TableRow>
                                <TableCell colSpan={8}>
                                    <Box className='tableloader'>
                                        <TableLoader />
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )}
                        {Math.ceil(totalCount / rowsPerPage) > 1 && (
                            <TableRow>
                                <TableCell colSpan={100}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <MUICancelButton
                                            title='Previous'
                                            disabled={page === 1}
                                            startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                            onClick={() => handlePageChange(null, page - 1)}
                                            sx={{ height: '36px' }}
                                        />

                                        <Pagination
                                            page={page}
                                            count={Math.ceil(totalCount / rowsPerPage)}
                                            onChange={handlePageChange}
                                            siblingCount={1}
                                            boundaryCount={1}
                                            shape="rounded"
                                            hideNextButton
                                            hidePrevButton
                                        />

                                        <MUICancelButton
                                            title='Next'
                                            startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(totalCount / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                            disabled={page === Math.ceil(totalCount / rowsPerPage)}
                                            onClick={() => handlePageChange(null, page + 1)}
                                            sx={{ height: '36px' }}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        )}
                    </Table>
                </Paper>

                {/* <Table>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                className="tablepagination"
                                page={page}
                                rowsPerPage={rowsPerPage}
                                onPageChange={handlePageChange}
                                onRowsPerPageChange={handleRowsPerPageChange}
                                rowsPerPageOptions={[10, 20, 50]}
                                count={totalCount || 0}
                            />
                        </TableRow>
                    </TableFooter>
                </Table> */}
            </Grid2>

        </Box>
    )
}

export default PerformanceTracker